export default {
    name: 'Focus Screen',
    studentMessage: 'Please pay attention to the Teacher now',
    teacherMessage: 'Focus Screen is currently active.',
    close: 'Dismiss',
};
